module.exports = __webpack_public_path__ + "media/images/icons/icon_anonymous_user_image-9474ff110931281bca5b842ff1bef603.svg";